import type { Product, ProductId } from "../types";

/** In-page product section id on the home page. */
export function productAnchor(id: ProductId): string {
  return `product-${id}`;
}

export function scrollToId(id: string, behavior: ScrollBehavior = "smooth"): void {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior, block: "start" });
  }
}

/**
 * Enter a product: open external URL only when configured.
 * Without a URL, intentionally no-op (links will be filled in later).
 */
export function enterProduct(product: Product): void {
  if (product.statusTone === "live" && product.url) {
    window.location.assign(product.url);
  }
  // No URL yet: click does nothing.
}

/** After route change, honor location.hash anchors. */
export function scrollToHash(behavior: ScrollBehavior = "smooth"): void {
  const hash = window.location.hash.replace(/^#/, "");
  if (!hash) return;
  requestAnimationFrame(() => {
    scrollToId(hash, behavior);
  });
}
